import {ILogService, IPromise, IQService} from 'angular';
import {IState, IStateParamsService} from 'angular-ui-router';
import VersicherungsbeitragModelManager from '../core/service/VersicherungsbeitragModelManager';
import {RouterHelper} from '../dvbModules/router/route-helper-provider';
import TSVersicherungsbeitrag from '../models/TSVersicherungsbeitrag';

versicherungsbeitraegeRun.$inject = ['RouterHelper'];

/* @ngInject */
export function versicherungsbeitraegeRun(routerHelper: RouterHelper) {
    routerHelper.configureStates(getStates());
}

function getStates(): IState[] {
    return [
        {
            name: 'versicherungsbeitraege',
            template: '<versicherungsbeitraege-list-view flex="auto" class="overflow-scroll"></versicherungsbeitraege-list-view>',
            url: '/versicherungsbeitraege',

        },
        {
            name: 'versicherungsbeitragschaden',   //todo name verwirrend -umbennen
            template: '<versicherungsbeitrag-schaden-view flex="auto" class="overflow-scroll" versicherungsbeitrag="$resolve.versicherungsbeitrag"></versicherungsbeitrag-schaden-view>',
            url: '/versicherungsbeitragschaden/:createNew/:versicherungsbeitragId',
            resolve: {versicherungsbeitrag: getOrCreateVersicherungsbeitrag},
        },
        {
            name: 'versicherungbeitragversicherter',
            template: '<versicherungsbeitrag-versicherter-view flex="auto" class="overflow-scroll" versicherungsbeitrag="$resolve.versicherungsbeitrag"></versicherungsbeitrag-versicherter-view>',
            url: '/versicherungbeitragversicherter/:versicherungsbeitragId',
            resolve: {versicherungsbeitrag: getVersicherungsbeitrag},
        },
        {
            name: 'versicherungbeitragbeitrag',
            template: '<versicherungsbeitrag-beitrag-view flex="auto" class="overflow-scroll" versicherungsbeitrag="$resolve.versicherungsbeitrag"></versicherungsbeitrag-beitrag-view>',
            url: '/versicherungbeitragbeitrag/:versicherungsbeitragId',
            resolve: {versicherungsbeitrag: getVersicherungsbeitrag},
        },

    ];
}

export class INewFallStateParams implements IStateParamsService {
    createNew: string;
    versicherungsbeitragId: string;
}

export class IFallStateParams implements IStateParamsService {
    versicherungsbeitragId: string;
}

getOrCreateVersicherungsbeitrag.$inject = ['$stateParams', '$q', 'VersicherungsbeitragModelManager'];

/* @ngInject */
export function getOrCreateVersicherungsbeitrag($stateParams: INewFallStateParams, $q: IQService,
                                                versicherungsbeitragModelManager: VersicherungsbeitragModelManager): IPromise<TSVersicherungsbeitrag> {
    if ($stateParams) {
        let versicherungsbeitragIdParam = $stateParams.versicherungsbeitragId;
        let createNewParam = $stateParams.createNew;
        if (createNewParam === 'false' && versicherungsbeitragIdParam) {
            return versicherungsbeitragModelManager.openVersicherungsbeitrag(versicherungsbeitragIdParam);
        }
    }
    return versicherungsbeitragModelManager.initNewVersicherungsbeitrag();
}

getVersicherungsbeitrag.$inject = ['$stateParams', '$q', 'VersicherungsbeitragModelManager', '$log'];

/* @ngInject */
export function getVersicherungsbeitrag($stateParams: IFallStateParams, $q: IQService,
                                        versicherungsbeitragModelManager: VersicherungsbeitragModelManager,
                                        log: ILogService): IPromise<TSVersicherungsbeitrag> {
    if ($stateParams) {
        let versicherungsbeitragIdParam = $stateParams.versicherungsbeitragId;
        if (versicherungsbeitragIdParam) {
            if (versicherungsbeitragModelManager.isVersicherungsbeitrag(versicherungsbeitragIdParam)) {
                return $q.when(versicherungsbeitragModelManager.getVersicherungsbeitrag()!);     //we already checked for null, hence !
            } else {
                return versicherungsbeitragModelManager.openVersicherungsbeitrag(versicherungsbeitragIdParam);
            }
        }
    }
    log.error('Can`t open versicherungsbeitrag on view!!! createOrUpdate a new one...');
    return versicherungsbeitragModelManager.initNewVersicherungsbeitrag();
}



// WEBPACK FOOTER //
// ./src/app/versicherungsbeitraege/versicherungsbeitraege.route.ts